module.exports = __webpack_public_path__ + "static/media/arrow_right_black_24dp.8bffbfa4.svg";